import { fork, put, takeEvery, all } from 'redux-saga/effects';
import {
  SystemApi, SystemControllerDtoAppConfigListResponse
} from '../../models/src';
import config from '../../../config/config';
import { UPLOADED_IMAGE_LIST_REQUEST } from '../../constants/app/devImageUploadConstants';
import { getErrorMessage } from '../../../utils/serverErrorCheck';

const api = new SystemApi(config.API_CLIENT);

function* uploadedImageListRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const result = yield api.apiSystemAppConfigListPost( () => {});
    const data = api.apiClient.deserialize(result, SystemControllerDtoAppConfigListResponse);
    console.log(data);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* devImageUploadRootSaga() {
  yield all([
    takeEvery(UPLOADED_IMAGE_LIST_REQUEST, uploadedImageListRequestSaga),
  ]);
}

const devImageUploadSaga = [
  fork(devImageUploadRootSaga)
];

export default devImageUploadSaga;
